import { statusOptionsPerRole } from "src/redux/slices/purchase-order";

type UserRole = string;
type Status = string;

export const isStatusAllowedForUser = (
  userRoles: UserRole[] = [],
  status: Status
): boolean => {
  // Owner has access to all statuses
  if (userRoles.includes('owner')) return true;

  for (const role of userRoles) {
    const allowedStatuses = statusOptionsPerRole[role];
    if (allowedStatuses?.includes(status)) {
      return true;
    }
  }

  return false;
};
